import { render, staticRenderFns } from "./BreadCrumbItem.vue?vue&type=template&id=6c24c483&"
import script from "./BreadCrumbItem.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports